<div class="header-container">
  <span></span>
  <span
    class="header-container__header lx-section-title"
    id="modal-basic-title">
    {{ config.title }}
  </span>
  <span
    class="header-container__close"
    type="button"
    (click)="close()">
    <i class="lx-icon lx-close-x"></i>
  </span>
</div>

<div class="input-container">
  {{ config.body }}
</div>

<div class="footer">
  <button
    class="lx-btn lx-btn-secondary"
    (click)="close()">
    Cancel
  </button>
  <button
    class="lx-btn lx-btn-primary"
    (click)="onActionClick()">
    {{ config.action }}
  </button>
</div>
